/* A mutation list for collaborators */
export const GET_CUT_OFF_TIME_LIST = 'GET_CUT_OFF_TIME_LIST';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js